import { Snackbar } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import RegularButton from "components/CustomButtons/Button";
import { useState } from "react";
import { submitQuestionChoices } from "services/PdfPlayerServices/questionChoices";
import * as XLSX from "xlsx";
import styles from "../../../Styles/questionCard.module.css";


export default function AttemptQuestionPanel({ sections, originalData, onFinish }) {

    const [expanded, setExpanded] = useState(
        sections.map(() => true)
    );

    const [stateSections, setStateSections] = useState(sections);
    const [open, setOpen] = useState(false);
    const [alertMessage, setAlertMessage] = useState(null);
    const [severity, setSeverity] = useState("success");

    const handleExcelUpload = (e, sIndex) => {
        const file = e.target.files[0];
        if (!file) return;

        const reader = new FileReader();

        reader.onload = (evt) => {
            const data = new Uint8Array(evt.target.result);
            const workbook = XLSX.read(data, { type: "array" });

            const sheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[sheetName];

            const jsonData = XLSX.utils.sheet_to_json(worksheet);

            const updatedSections = [...stateSections];
            const currentSection = updatedSections[sIndex];

            jsonData.forEach((row) => {
                const qNumber = Number(row.QuestionNumber);
                const ans = row.Answer?.toString().trim();

                if (!qNumber || !ans) return;

                // 🔥 section-wise numbering (1-based)
                const questionIndex = qNumber - 1;

                if (currentSection.questions[questionIndex]) {
                    currentSection.questions[questionIndex].response = ans;
                }
            });

            setStateSections(updatedSections);
        };

        reader.readAsArrayBuffer(file);
    };

    const toggleSection = (index) => {
        const copy = [...expanded];
        copy[index] = !copy[index];
        setExpanded(copy);
    };

    const handleSelect = (sIndex, qIndex, value) => {
        const updated = [...stateSections];
        updated[sIndex].questions[qIndex].response = value;
        setStateSections(updated);
    };

    const handleSubmit = async () => {
        try {
            const payload = stateSections.flatMap(section =>
                section.questions.map(q => ({
                    ...q.questionChoice,
                    choiceIdAnswers: q.response || null
                }))
            );

            console.log("Final Payload:", payload);

            const response = await submitQuestionChoices(payload);
            showSnackBar("Test Saved Successfully")
            setTimeout(() => {
                onFinish();
            }, 3000)

            console.log("API Response:", response);

        } catch (error) {
            console.error("Submit Failed:", error);
        }
    };

    const showSnackBar = (message, sev) => {
        setSeverity(sev ?? "success");
        setAlertMessage(message);
        setOpen(true);
    };
    const handleClose = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }
        setAlertMessage(null);
        setOpen(false);
    };

    return (
        <div style={{ padding: 20 }}>
            {stateSections.map((section, sIndex) => (
                <div key={section.poolId} style={{ marginBottom: 20 }}>

                    {/* Section Header */}
                    <div
                        onClick={() => toggleSection(sIndex)}
                        style={{
                            cursor: "pointer",
                            fontWeight: 600,
                            padding: "10px",
                            background: "#f5f5f5",
                            borderRadius: 6,
                            marginBottom: 10
                        }}
                    >
                        Section {section.sequence}
                        <span style={{ float: "right" }}>
                            {expanded[sIndex] ? "▲" : "▼"}
                        </span>
                    </div>

                    {/* Upload per section */}
                    <div style={{ marginBottom: 15 }}>
                        <label style={{ fontWeight: 500 }}>
                            Upload Answers Using Excel
                        </label>

                        <input
                            type="file"
                            accept=".xlsx, .xls"
                            onChange={(e) => handleExcelUpload(e, sIndex)}
                            style={{ display: "block", marginTop: 5 }}
                        />
                    </div>

                    {expanded[sIndex] &&
                        section.questions.map((q, qIndex) => (
                            <div
                                key={q.id}
                                className={styles.questionCard}
                            >
                                <div className={styles.questionRow}>
                                    <div className={styles.questionNumber}>
                                        Q{q.sequence}.
                                    </div>

                                    <div className={styles.optionsContainer}>
                                        {q.type === "SCQ" &&
                                            q.options.map(option => (
                                                <label
                                                    key={option}
                                                    className={`${styles.optionBox} ${q.response === option
                                                        ? styles.selected
                                                        : ""
                                                        }`}
                                                >
                                                    <input
                                                        type="radio"
                                                        name={`s-${sIndex}-q-${qIndex}`}
                                                        checked={
                                                            q.response === option
                                                        }
                                                        onChange={() =>
                                                            handleSelect(
                                                                sIndex,
                                                                qIndex,
                                                                option
                                                            )
                                                        }
                                                    />
                                                    <span>{option}</span>
                                                </label>
                                            ))}
                                        {q.type === "Numerical" && (
                                            <input
                                                type="number"
                                                value={q.response || ""}
                                                onChange={(e) =>
                                                    handleSelect(
                                                        sIndex,
                                                        qIndex,
                                                        e.target.value
                                                    )
                                                }
                                                style={{
                                                    padding: "8px",
                                                    borderRadius: "6px",
                                                    border: "1px solid #ccc",
                                                    width: "150px"
                                                }}
                                                placeholder="Enter answer"
                                            />
                                        )}
                                    </div>
                                </div>
                            </div>
                        ))}
                </div>
            ))}

            <RegularButton color="primary" onClick={handleSubmit}>
                Save
            </RegularButton>
            {<Snackbar
                open={open}
                autoHideDuration={2000}
                onClose={handleClose}
                anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
            >
                <Alert onClose={handleClose} severity={severity}>
                    {alertMessage}
                </Alert>
            </Snackbar>}
        </div>
    );
}